import { Campaign, CampaignTypes } from '@/models';
import { Milestone, SideQuest } from '@/models/leaderboard';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgLeaderboardCyoPanel',
})
export default class CmgLeaderboardCyoPanel extends Vue {

  @Prop({ required: true, type: Object })
  milestone!: Milestone;

  get cyoPanelBorderUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxPinkYellowBorder.default;
  }

  get milestoneTitle(): string {
    if (!this.milestone) { return ''; }
    const monthName = new Date(2000, this.milestone.month - 1, 1).toLocaleString('en-US', { month: 'long' });
    return `${monthName} ${this.milestone.title}`;
  }

  get milestoneEndDate(): string {
    const raw = this.milestone.eligibleForChooseYourOwnRewardExpirationDate;
    const date = raw ? (typeof raw === 'string' ? new Date(raw) : raw) : null;
    const dateString = date ? date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }) : '';
    return dateString ? `Choose before ${dateString}` : '';  
  }

  onClickCard(): void {
    this.$services.ui.setModalVisibility('summerLeaderboardCyoReward', true, { milestone: this.milestone });
  }
}
